import Navbar from "./components/Navbar";
import FooterSection from "./components/FooterSection";

export default function NewFourWhitepaperPage() {
  return (
    <div className="min-h-screen bg-[#fff8ef] text-[#171717] overflow-hidden">
      <div className="fixed inset-0 pointer-events-none opacity-70" style={{ background: "radial-gradient(circle at 12% 18%, rgba(255,205,82,0.24), transparent 18%), radial-gradient(circle at 82% 14%, rgba(255,126,78,0.18), transparent 20%), radial-gradient(circle at 74% 68%, rgba(89,170,255,0.18), transparent 18%)" }} />
      <Navbar />
      <main className="relative z-10 pt-[110px] pb-20">
        <section className="pb-12 border-b border-[#171717]/8">
          <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-[1fr_1fr] gap-8 items-center">
            <div>
              <p className="text-[11px] uppercase tracking-[0.24em] text-[#6b6b6b] font-bold mb-4">Resource • Whitepaper</p>
              <h1 className="text-5xl md:text-6xl font-black tracking-[-0.06em] leading-[0.94] mb-5">A sharper model for growth after search stops behaving like search.</h1>
              <p className="text-[#4f4f4f] text-lg leading-relaxed max-w-2xl mb-8">This resource is for founders and growth leads who want the full Flowvory operating model in one place, from GEO and structure to conversion logic and demand quality.</p>
              <div className="flex flex-wrap gap-4">
                <button onClick={() => window.dispatchEvent(new Event("flowvory:open-whitepaper"))} className="px-7 py-4 rounded-full bg-[#171717] text-[#fff8ef] text-base font-bold shadow-[8px_8px_0_rgba(255,126,78,0.20)]">Get the Whitepaper</button>
                <div className="px-5 py-4 rounded-full bg-white/80 border border-[#171717]/10 text-sm font-semibold rotate-[2deg]">Built for operators who want frameworks, not trend-chasing</div>
              </div>
            </div>
            <div className="rounded-[34px] border border-[#171717]/10 bg-white/84 p-7 shadow-[0_30px_100px_rgba(23,23,23,0.08)]">
              <p className="text-[10px] uppercase tracking-[0.22em] text-[#6b6b6b] font-bold mb-4">What the reader should understand by the end</p>
              <div className="space-y-3">
                {[
                  "Why GEO changes the visibility model",
                  "What the data layer is really for",
                  "How content, CRO, and scoring support each other",
                  "Where growth teams usually break the system",
                ].map((item, idx) => (
                  <div key={item} className={`rounded-[22px] border border-[#171717]/10 px-4 py-4 text-sm font-semibold ${idx === 1 ? "bg-[#dff3ff] rotate-[-1deg]" : idx === 2 ? "bg-[#fff0db] rotate-[1deg]" : "bg-[#f9f7f1]"}`}>{item}</div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-12">
          <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-3 gap-5">
            {[
              ["For founders", "When the old channel model still half-works, but you know it is getting weaker."],
              ["For growth leads", "When the team needs a more coherent operating framework than random experiments."],
              ["For operators", "When the question is no longer just traffic, but how the whole system fits together."],
            ].map(([title, text], idx) => (
              <article key={title} className={`rounded-[30px] border border-[#171717]/10 p-6 shadow-[0_18px_50px_rgba(23,23,23,0.05)] ${idx === 1 ? "bg-[#171717] text-white rotate-[-1deg]" : idx === 2 ? "bg-[#fff0db] rotate-[1deg]" : "bg-white/88"}`}>
                <h3 className="text-2xl font-black tracking-[-0.04em] leading-snug mb-3">{title}</h3>
                <p className={`leading-relaxed ${idx === 1 ? "text-white/76" : "text-[#4f4f4f]"}`}>{text}</p>
              </article>
            ))}
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
